import request from '@/services/interceptor.js'

export const get_cambiGomme = (filtri) => {
    return request({ url: '/cambiogomme', method: 'get', params: filtri || {}, loadingBar: true })
}

export const create_cambioGomme = (par) => {
    return request({ url: '/cambiogomme', method: 'post', data: par, loadingBar: true })
}

export const update_cambioGomme = (id, par) => {
    return request({ url: `/cambiogomme/${id}`, method: 'put', data: par, loadingBar: true })
}

export const elimina_cambioGomme = (id) => {
    return request({ url: `/cambiogomme/${id}`, method: 'delete', loadingBar: true })
}
